import axios from './axios';

export const getItemDescriptions = ({ params } = {}) => axios.get(`item_descriptions`, { params });
export const getItemDescription = ({ params, id } = {}) => axios.get(`item_descriptions/${id}`, { params });
export const createItemDescription = ({ data }) => axios.post(`item_descriptions`, data);
export const updateItemDescription = ({ id, data }) => axios.put(`item_descriptions/${id}`, data);
export const deleteItemDescription = ({ id }) => axios.delete(`item_descriptions/${id}`);